import { ReasonCreationForm } from 'components/Pages/ReverseLogistics/Configuration/Reasons';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

export const ReasonCreationPage: React.FC = () => {
  const navigate = useNavigate();

  const onCreate = useCallback((): void => {
    navigate('/configuracoes/logistica-reversa/motivos');
  }, [navigate]);

  return (
    <Scaffold>
      <ReasonCreationForm onCreate={onCreate} />
    </Scaffold>
  );
};
